namespace Solovis.Reports.Parameters.Stats {

  export interface BenchmarksParameterOptions {
    firstBenchmark?: BenchmarkOption;
    excessReturn: boolean;
    policyTarget: boolean;
  }

  export interface BenchmarkOption {
    source: string;
    customBenchmark: any;
  }

  export class BenchmarksParameterControl extends Solovis.UI.BaseControl {

    private _options: BenchmarksParameterOptions;

    constructor(options) {
      super(options);
      this._options = (typeof options.initialValue !== "undefined") ? options.initialValue : null;
    }

    public async doRender() {
      let self = this;

      let label = $("<a>").text("Benchmarks").appendTo(this.container);
      label.click(function () {
        self._showEditor();
      });

      let editLink = $("<a>").appendTo(this.container)
        .css("padding-left", "5px")
        .html("<span class='fa fa-pencil'></span>");
      editLink.click(function () {
        self._showEditor();
      });
    }

    private _showEditor() {
      const editorDialog = new BenchmarksParameterEditorDialog({
        options: this._options,
        saveCallback: (data: BenchmarksParameterOptions) => this.setParameterValue(data),
      });
      editorDialog.show();
    }

    public _setCurrentSourceDataOptions(data) { this._options = data; }

    public setParameterValue(newValue, more?) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this, BenchmarksParameterControl, this._setCurrentSourceDataOptions, newValue, more);
    }

    public getParameterValue() { return Solovis.deepCopy(this._options); }

    public notifyParameterValueChanged() { $(this).trigger("parameterValueChanged"); }
  }


  export class BenchmarksParameterEditorDialog {

    private _opts: BenchmarksParameterOptions;
    private _saveCallback: (options: BenchmarksParameterOptions) => void;
    private formBuilder: Solovis.UI.InputControls.FormBuilder;

    public constructor(options: {
      options: BenchmarksParameterOptions;
      saveCallback: (options: BenchmarksParameterOptions) => void;
    }) {
      this._opts = options.options ?? {} as BenchmarksParameterOptions;
      this._saveCallback = options.saveCallback;
    }

    public show() {
      const options = this._opts;
      this.formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: $("<div>"),
        width: 600,
        labelColumnWidth: 220
      });

      this.formBuilder.addEntry({
        name: "firstBenchmark.source",
        label: "Benchmark",
        initialValue: options.firstBenchmark?.source ?? "Primary",
        editor: {
          type: "select",
          selectOptions: {
            data: [
              { text: "Primary", value: "Primary" },
              { text: "Secondary", value: "Secondary" },
              { text: "Custom", value: "Custom" },
            ]
          }
        }
      });

      this.formBuilder.addEntry({
        name: "firstBenchmark.customBenchmark",
        label: "",
        initialValue: options.firstBenchmark?.customBenchmark,
        editor: {
          type: "parameter",
          parameterOptions: {
            parameterType: "entityOrInvestment"
          }
        },
        isVisible: (formEntry) => {
          let mode = formEntry.formBuilder.getValueByName("firstBenchmark.source");
          return mode === "Custom";
        }
      });

      this.formBuilder.addEntry({
        name: "excessReturn",
        label: "Benchmark Excess Return",
        initialValue: options.excessReturn,
        editor: { type: "bool" },
      });

      this.formBuilder.addEntry({
        name: "policyTarget",
        label: "Policy Target",
        initialValue: options.policyTarget,
        editor: { type: "bool" },
      });

      this.formBuilder.setupDone();
      this.formBuilder.showAsDialog({
        title: "Edit Benchmarks",
        desiredWidth: 620,
        desiredHeight: 300,
        showSaveCancel: true,
        saveButtonText: "OK",
        saveCallback: () => {
          const newOptions: BenchmarksParameterOptions = {
            firstBenchmark: {
              source: this.formBuilder.getValueByName("firstBenchmark.source"),
              customBenchmark: this.formBuilder.getValueByName("firstBenchmark.customBenchmark"),
            },
            excessReturn: this.formBuilder.getValueByName("excessReturn"),
            policyTarget: this.formBuilder.getValueByName("policyTarget"),
          };
          this._saveCallback(newOptions);
          return true;
        }
      });
    }
  }
}
